import CardSystem, { getCardHandler } from '../CardSystem';
import TransformComponent from '../../../Component/Transform';
import { AnimationSystemEvent } from '../../Animation/AnimationSystem';
import BaseCardHandler from '../Handler/BaseCardHandler';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Interactable from '../../../Component/Interactable';
import { ICardStateTaskData } from '../../../State/Card/ICardState';

export default function UndoFoldCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    PlaySound('undo-move-use');

    const card = system.getCardByID(taskData.cards[0]);

    // Re-position card.
    system.stackContainer.addChild(card);
    card.getComponent(TransformComponent).position.set(0);

    // Set face-up.
    const handler: BaseCardHandler = getCardHandler(card);
    handler.setCardFaceUp(true);

    card.scene.emit(AnimationSystemEvent.STOP, card);

    card.getComponent(Interactable).buttonMode = true;

    const task = new CardAnimationTask(
        taskData,
        system,
        'UndoFold',
        card,
        undefined,
        true
    );
    system.taskQueue.queue(task);
}
